import { ErrorsType, FieldErrorTypes, TeacherHireType } from 'types';
import { ISelectOption } from 'components/atoms';
import i18n from '../../i18n';

export const CURRENCY_OPTIONS_RU = [
  { value: 'BYN', label: 'BYN' },
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' },
  { value: 'RUB', label: 'RUB' },
];

export const CURRENCY_OPTIONS_TEACHER_RU = [
  { value: 'Byn', label: 'BYN' },
  { value: 'Usd', label: 'USD' },
  { value: 'Eur', label: 'EUR' },
  { value: 'Rub', label: 'RUB' },
];

export const CURRENCY_OPTIONS_PL = [
  { value: 'PLN', label: 'PLN' },
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' },
];

export const CURRENCY_OPTIONS_TEACHER_PL = [
  { value: 'Pln', label: 'PLN' },
  { value: 'Usd', label: 'USD' },
  { value: 'Eur', label: 'EUR' },
];

export const WEEK_DAYS = [
  { value: 0, label: `${i18n.t('common.weekDays.monday')}` },
  { value: 1, label: `${i18n.t('common.weekDays.tuesday')}` },
  { value: 2, label: `${i18n.t('common.weekDays.wednesday')}` },
  { value: 3, label: `${i18n.t('common.weekDays.thursday')}` },
  { value: 4, label: `${i18n.t('common.weekDays.friday')}` },
  { value: 5, label: `${i18n.t('common.weekDays.saturday')}` },
  { value: 6, label: `${i18n.t('common.weekDays.sunday')}` },
];

/**
 * Lesson time of day (ТЗ 0100): Europe/Warsaw wall time, stored as-is —
 * value = label, 15-minute step 00:00..23:45.
 */
export const LESSON_TIME_STEP_MINUTES = 15;

const padTime = (value: number): string => String(value).padStart(2, '0');

export const TIME_OPTIONS: { value: string; label: string }[] = Array.from(
  { length: (24 * 60) / LESSON_TIME_STEP_MINUTES },
  (_, index) => {
    const minutes = index * LESSON_TIME_STEP_MINUTES;
    const label = `${padTime(Math.floor(minutes / 60))}:${padTime(
      minutes % 60,
    )}`;
    return { value: `${label}:00`, label };
  },
);

/** Default lesson slot for a new schedule row: 19:00–22:00 (Warsaw). */
export const DEFAULT_LESSON_START_OPTION = TIME_OPTIONS.find(
  (option) => option.label === '19:00',
) as { value: string; label: string };

export const DEFAULT_LESSON_END_OPTION = TIME_OPTIONS.find(
  (option) => option.label === '22:00',
) as { value: string; label: string };

export const TEACHER_TYPE_OPTIONS: ISelectOption<string>[] = [
  { value: TeacherHireType.Se, label: `${i18n.t('common.teacherTypes.se')}` },
  { value: TeacherHireType.Ie, label: `${i18n.t('common.teacherTypes.ie')}` },
  { value: TeacherHireType.Np, label: `${i18n.t('common.teacherTypes.np')}` },
  { value: TeacherHireType.Le, label: `${i18n.t('common.teacherTypes.le')}` },
];

export const TEACHER_TYPE_COUNT_FIELDS = {
  [TeacherHireType.Ie]: 5,
  [TeacherHireType.Se]: 7,
  [TeacherHireType.Np]: 6,
  [TeacherHireType.Le]: 6,
};

/** Ключи дней недели в порядке бэкенда (`settings.DAY_OF_CLASS`: 0 = пн). */
export const WEEK_DAY_KEYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;

/**
 * Короткие подписи дней на ТЕКУЩЕМ языке. Считаются при отрисовке через `t`:
 * константа `weekDays` ниже вычисляется один раз при загрузке модуля и
 * остаётся на языке, который был в тот момент (в RU показывались «PN, WT…»).
 */
export const weekDayShortLabels = (t: (key: string) => string): string[] =>
  WEEK_DAY_KEYS.map((key) => `${t(`common.weekDaysShort.${key}`)}`);

/** @deprecated язык фиксируется при загрузке — используйте `weekDayShortLabels(t)`. */
export const weekDays = [
  `${i18n.t('common.weekDaysShort.monday')}`,
  `${i18n.t('common.weekDaysShort.tuesday')}`,
  `${i18n.t('common.weekDaysShort.wednesday')}`,
  `${i18n.t('common.weekDaysShort.thursday')}`,
  `${i18n.t('common.weekDaysShort.friday')}`,
  `${i18n.t('common.weekDaysShort.saturday')}`,
  `${i18n.t('common.weekDaysShort.sunday')}`,
];

export const invalidPhoneError: ErrorsType<{ phone: string }> = {
  phone: {
    message: `${i18n.t('common.wrongPhoneNumber')}`,
    type: FieldErrorTypes.SERVER_ERROR,
  },
};

export const MONTH_NAMES = [
  `${i18n.t('common.months.january')}`,
  `${i18n.t('common.months.february')}`,
  `${i18n.t('common.months.march')}`,
  `${i18n.t('common.months.april')}`,
  `${i18n.t('common.months.may')}`,
  `${i18n.t('common.months.june')}`,
  `${i18n.t('common.months.july')}`,
  `${i18n.t('common.months.august')}`,
  `${i18n.t('common.months.september')}`,
  `${i18n.t('common.months.october')}`,
  `${i18n.t('common.months.november')}`,
  `${i18n.t('common.months.december')}`,
];
